import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "@/hooks/useTableFilters";
import ProjectCombobox from "components/directus/combobox/project";
import { JOB_TYPES } from "@/lib/constants";
import { RadioGroup, RadioGroupItem } from "ui/components/radio-group";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import EvtUserMultiSelect from "components/user/multiselect";
import { StatusMultiSelect } from "components/status/multiselct";
import DepartmentCombobox from "components/directus/department-combobox";

export default function ReportJobFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,

    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      sales_coordinator: undefined,
      status: undefined,
      skills: undefined,
      flag: undefined,
      department: undefined,
      ...defaultFilters,
    },
  });

  return (
    <div className="w-full p-4 space-y-4">
      <div>
        <Label className="mb-2 text-sm">Department</Label>
        <DepartmentCombobox
          values={localFilters?.coordinator?.department?._in || []}
          multiselect
          hideLabel
          className="w-full"
          dependsOn={isOpen}
          onChange={(values) =>
            handleSetLocalFilters({
              ...localFilters,
              coordinator: {
                ...localFilters.coordinator,
                department: values?.length ? { _in: values } : undefined,
              },
            })
          }
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Job Coordinator</Label>
        <EvtUserMultiSelect
          values={localFilters?.coordinator?._in || []}
          onChange={(values) =>
            handleSetLocalFilters({
              ...localFilters,
              coordinator: values?.length ? { _in: values } : undefined,
            })
          }
          filter={EMPLOYEE_FILTERS.jobs_coordinating}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Project Coordinator</Label>
        <EvtUserMultiSelect
          values={localFilters?.project?.coordinator?._in || []}
          onChange={(values) =>
            handleSetLocalFilters({
              ...localFilters,
              project: {
                ...localFilters.project,
                coordinator: values?.length ? { _in: values } : undefined,
              },
            })
          }
          filter={EMPLOYEE_FILTERS.projects_coordinating}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Account Manager</Label>
        <EvtUserMultiSelect
          values={localFilters?.project?.account_manager?._in || []}
          onChange={(values) =>
            handleSetLocalFilters({
              ...localFilters,
              project: {
                ...localFilters.project,
                account_manager: values?.length ? { _in: values } : undefined,
              },
            })
          }
          filter={EMPLOYEE_FILTERS.account_manager}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Sales Coordinator</Label>
        <EvtUserMultiSelect
          values={localFilters?.project?.sales_coordinator?._in || []}
          onChange={(values) =>
            handleSetLocalFilters({
              ...localFilters,
              project: {
                ...localFilters.project,
                sales_coordinator: values?.length ? { _in: values } : undefined,
              },
            })
          }
          filter={EMPLOYEE_FILTERS.sales_coordinating}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Type</Label>
        <RadioGroup
          value={localFilters?.type?._eq || ""}
          onValueChange={(value) =>
            handleSetLocalFilters({
              ...localFilters,
              type: value ? { _eq: value } : undefined,
            })
          }
          className="grid grid-cols-2 gap-2"
        >
          {Object.entries(JOB_TYPES).map(([key, type]) => {
            if (key === "recurring") return;
            return (
              <div key={key} className="flex items-center gap-2">
                <RadioGroupItem
                  value={key}
                  id={`type-${key}`}
                  className="text-base"
                />
                <label
                  htmlFor={`type-${key}`}
                  className="text-sm cursor-pointer"
                >
                  {type.label}
                </label>
              </div>
            );
          })}
        </RadioGroup>
      </div>
      <div>
        <div>
          <Label className="mb-2 text-sm">Status</Label>
          <StatusMultiSelect
            values={localFilters?.status?._in || []}
            onChange={(values) =>
              handleSetLocalFilters({
                ...localFilters,
                status: values?.length ? { _in: values } : undefined,
              })
            }
            collection="jobs"
          />
        </div>
      </div>
      <div>
        <Label className="mb-2 text-sm">Project</Label>
        <ProjectCombobox
          value={localFilters.project?._eq}
          className="w-full"
          hideLabel
          dependsOn={isOpen}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              ...localFilters,
              project: {
                ...localFilters.project,
                _eq: selectedItem,
              },
            })
          }
        />
      </div>
      {/* <div>
        <Label className="mb-2 text-sm">Flag</Label>
        <CommonSelect
          placeholder="Select"
          value={localFilters?.flag?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              flag: { _eq: selectedItem?.id, __selectedItem: selectedItem },
            })
          }
          items={jobflag}
          className="!w-full"
        />
      </div> */}

      {/* Action Buttons */}

      <div className="flex place-self-end gap-4">
        <Button variant="outline" onClick={clearLocalFilters}>
          Clear
        </Button>

        <Button onClick={() => applyFilters()}>Apply</Button>
      </div>
    </div>
  );
}
